// Application constants
export const projectTitle = "MediaCaption";

export const SUPPORTED_FILE_FORMATS = [
  "MP3",
  "MP4",
  "WAV",
  "FLAC",
  "AMR",
  "OGG",
  "WebM",
  "M4A",
  "AAC",
];

// Translation language options - most common languages for translation
export const TRANSLATION_LANGUAGE_OPTIONS = [
  { label: "Arabic", value: "ar" },
  { label: "Chinese (Simplified)", value: "zh" },
  { label: "Chinese (Traditional)", value: "zh-TW" },
  { label: "Dutch", value: "nl" },
  { label: "English", value: "en" },
  { label: "French", value: "fr" },
  { label: "German", value: "de" },
  { label: "Hindi", value: "hi" },
  { label: "Italian", value: "it" },
  { label: "Japanese", value: "ja" },
  { label: "Korean", value: "ko" },
  { label: "Portuguese", value: "pt" },
  { label: "Russian", value: "ru" },
  { label: "Spanish", value: "es" },
  { label: "Thai", value: "th" },
  { label: "Turkish", value: "tr" },
  { label: "Vietnamese", value: "vi" },
];

export const TABLE_CONFIG = {
  PAGE_SIZE: 10,
  WIDTHS_STORAGE_KEY: "React-Table-Widths",
};

export const COLUMN_DISPLAY = [
  { id: "name", visible: true },
  { id: "filename", visible: true },
  { id: "statusMessage", visible: true },
  { id: "translationStatus", visible: true },
  { id: "srt", visible: true },
  { id: "vtt", visible: true },
  { id: "docx", visible: true },
  { id: "translatedSrt", visible: true },
  { id: "translatedVtt", visible: true },
  { id: "translatedDocx", visible: true },
  { id: "languageToDisplay", visible: true },
  { id: "translationLanguageToDisplay", visible: true },
  { id: "description", visible: true },
  { id: "costSavings", visible: true },
  { id: "createDate", visible: true },
];

export const UTILITIES = [
  {
    type: "menu-dropdown",
    text: "Notifications",
    iconName: "notification",
    items: [{ text: "No notifications", disabled: true }],
  },
  {
    type: "button",
    text: "Stats",
    href: "/stats",
  },
  {
    type: "button",
    text: "Analytics",
    href: "/analytics",
    iconName: "status-info",
  },
  {
    type: "button",
    text: "About",
    href: "https://w.amazon.com/bin/view/AWS_Video_Team/GenAI/MediaStorm",
    iconName: "info",
    external: true,
  },
  {
    type: "button",
    text: "Support",
    href: "https://t.corp.amazon.com/create/templates/b6638cca-a8c2-4d13-83e1-d263fd66f829",
    iconName: "settings",
  },
  {
    type: "button",
    text: "Feedback",
    href: "#feedback",
    iconName: "contact",
    id: "feedback-button",
  },
] as const;
